import {initializeApp} from 'firebase/app';

export const isLocalHost = typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const LEGACY_HOSTNAMES = new Set(["soundspots.dk", "www.soundspots.dk"]);
const CANONICAL_HOSTNAME = "soundspots.app";

if (typeof window !== "undefined" && LEGACY_HOSTNAMES.has(window.location.hostname)) {
    const nextUrl = new URL(window.location.href);
    nextUrl.hostname = CANONICAL_HOSTNAME;
    window.location.replace(nextUrl.toString());
}

const authDomain = isLocalHost ?
    "fire-starter-77890.firebaseapp.com" :
    (typeof window !== "undefined" ?
        (LEGACY_HOSTNAMES.has(window.location.hostname) ? CANONICAL_HOSTNAME : window.location.hostname) :
        CANONICAL_HOSTNAME);

console.log("[auth-trace] Firebase config", {
    host: typeof window !== "undefined" ? window.location.host : null,
    authDomain
});

export const firebaseApp = initializeApp({
        apiKey: "AIzaSyCcdolz5IqPuQZ5MuZdXEHVgdoTukvbblE",
        authDomain,
        projectId: "fire-starter-77890",
        storageBucket: "fire-starter-77890.appspot.com",
        messagingSenderId: "55265832614",
        appId: "1:55265832614:web:ce5d28c96aaf848eef0e67"
    }
);
